import { handleErrors, handleUnauthorized } from "../util/api-utils";

export function initialize(request) {
    return fetch("api/Onboarding/Initialize", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleUnauthorized)
        .then(handleErrors);
};

export function update(request, successCallback, finallyCallback, errorCallback = console.error) {
    fetch("api/Onboarding/Update", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleUnauthorized)
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback)
        .finally(finallyCallback);
};

export function updateMany(requests, successCallback, finallyCallback, errorCallback = console.error) {
    fetch("api/Onboarding/UpdateMany", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(requests)
    })
        .then(handleUnauthorized)
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback)
        .finally(finallyCallback);
};

export function uploadOnboardingErrorsAndOmissions(fileUploadRequest, successCallback, errorCallback) {
    const formData = new FormData();

    formData.append("Target", fileUploadRequest.target);
    formData.append("UploadedBy", fileUploadRequest.uploadedBy);

    fileUploadRequest.files.forEach((file) => {
        formData.append("Files", file);
    });

    fetch("api/Onboarding/UploadOnboardingErrorsAndOmissions", {
        method: "post",
        headers: {
            "Accept": "application/json"
        },
        body: formData
    })
        .then(handleUnauthorized)
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}

export function recall(request, successCallback, errorCallback, finallyCallback) {
    fetch("api/Onboarding/Recall", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleUnauthorized)
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback)
        .finally(finallyCallback);
};

export function clearSession(finallyCallback) {
    return fetch("api/Onboarding/ClearSession", {
        method: "post",
    })
        .then(handleUnauthorized)
        .then(handleErrors)
        .catch(console.error)
        .finally(finallyCallback);
};
